import { render, staticRenderFns } from "./taxRemunerationList.vue?vue&type=template&id=18c88724&scoped=true&"
import script from "./taxRemunerationList.vue?vue&type=script&lang=js&"
export * from "./taxRemunerationList.vue?vue&type=script&lang=js&"
import style0 from "./taxRemunerationList.vue?vue&type=style&index=0&id=18c88724&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c88724",
  null
  
)

export default component.exports